import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { couponActions } from "@/store/actions/coupon.action";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Coupon } from "@/types/coupon";
import React from "react";

const CouponStatusCell = ({ coupon }: { coupon: Coupon }) => {
  const dispatch = useAppDispatch();
  const { id, enabled } = coupon;
  const loading = useAppSelector(
    (state) => state.coupon.loadingById[id] || false,
  );
  const handleToggle = () => {
    if (loading) return;
    if (enabled) {
      dispatch(couponActions.deactivateCoupon(id));
    } else {
      dispatch(couponActions.activateCoupon(id));
    }
  };
  return (
    <div
      className="flex items-center gap-2"
      onClick={(e) => e.stopPropagation()}
    >
      <Badge
        variant="secondary"
        className={`rounded-full px-2 py-1 text-xs font-medium ${
          enabled
            ? "bg-notification-success/16 hover:bg-notification-success/16 text-notification-success border-0"
            : "bg-notification-error/16 hover:bg-notification-error/16 text-notification-error border-0"
        }`}
      >
        {enabled ? "Active" : "In Active"}
      </Badge>
      <Switch
        onCheckedChange={handleToggle}
        checked={enabled}
        className="data-[state=checked]:bg-notification-success data-[state=unchecked]:bg-notification-error scale-75"
      />
    </div>
  );
};

export default CouponStatusCell;
